import { TDropdownQuestions } from './TalkToUs.types';

export const QUESTION_OPTIONS: TDropdownQuestions = [
    { label: 'I would like to make a reservation', value: 'Reservation' },
    { label: 'I need assistance with an existing reservation', value: 'Options' },
    { label: 'I have activity questions', value: 'ActivityQuestions' },
];
